export default __webpack_public_path__ + "static/gangli-91bf23bf4832733d98787bba6381a185.jpg";